import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { Router } from '../../routes';
import { selectProduct } from "../../redux/actions";
import { HotelParamsLine, DropdownContainer } from "../index";
import { Checkbox } from "../../components";
import { getCategory, slugify, PRODUCT_TYPES_LIST } from '../../utils';

const { ParamsOption, CheckboxList } = HotelParamsLine;

const mapStateToProps = state => ({
  product: state.userPreferences.product,
  market: state.userPreferences.city.market,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductSelection: selectProduct,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class ProductSelector extends Component {
  static propTypes = {
    product: PropTypes.string,
    handleProductSelection: PropTypes.func,
    currentDropdown: PropTypes.string,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    market: PropTypes.string,
  };

  getProductTitle = option => {
    const splitOptions = option.split(',');
    let optionsMessage;

    if (splitOptions.length > 1) {
      optionsMessage = `${splitOptions.length} options selected`;
    } else if (splitOptions.length === 1) {
      optionsMessage = splitOptions;
    }

    return optionsMessage;
  };

  handleCheckboxSelect = evt => {
    const { handleProductSelection, product, market } = this.props;
    const { target } = evt;
    let checkboxOptions;

    if (Router.query.product) {
      checkboxOptions = Router.query.product.split(',');
    } else {
      checkboxOptions = product.split(',');
    }

    const containedOptionIndex = checkboxOptions.findIndex(option => option.trim() === target.value);

    if (containedOptionIndex !== -1) {
      checkboxOptions.splice(containedOptionIndex, 1);
    } else {
      checkboxOptions.push(target.value);
    }

    const filteredCheckboxOptions = checkboxOptions.filter(option => option.length !== 0);
    const selectedProduct = filteredCheckboxOptions.join(',');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(selectedProduct),
      product: selectedProduct,
    }, { shallow: true });

    handleProductSelection(selectedProduct);
  };

  render() {
    const { handleCheckboxSelect } = this;
    const { currentDropdown, handleDropdownClick, handleCloseDropdown, product } = this.props;

    return (
      <Fragment>
        <ParamsOption
          type="button"
          name="product"
          onClick={handleDropdownClick}
          isOpened={currentDropdown === 'product'}
          isActive={product}
        >
          {product ? this.getProductTitle(product) : 'Select your way'}
        </ParamsOption>
        {currentDropdown === 'product' && (
          <DropdownContainer name="product" handleCloseButtonClick={handleCloseDropdown} onClickOutside={handleCloseDropdown}>
            <CheckboxList onChange={handleCheckboxSelect}>
              {PRODUCT_TYPES_LIST.map(productType => (
                <li key={productType.id}>
                  <Checkbox
                    readonly
                    description={productType.description}
                    name={productType.name}
                    value={productType.name}
                    checked={product.split(',').includes(productType.name)}
                    id={productType.id}
                    label={productType.name}
                  />
                </li>
              ))}
            </CheckboxList>
          </DropdownContainer>
        )}
      </Fragment>
    );
  }
}

export default ProductSelector;
